
import { MobileMoneyOperator } from "../../account/constants/dealer-basic-data";
import { PaymentStatus } from "../constants/general-basic-data";
import { Price } from "./string-data.model";

 export class Payment {

    mobileMoneyOperator: MobileMoneyOperator = MobileMoneyOperator.MTN;
    mobileMoneyPhoneCode = 0;
    mobileMoneyPhoneNumber = 0;
    
    price: Price;

    status: PaymentStatus = PaymentStatus.NEW;

     constructor(){
        this.price = Price.getDefault();
     }

 }